import { Select, SelectTrigger } from '@riac/design-system';
import { SelectAriaControlContainer } from '@riac/design-system';
import styled from 'styled-components';

export const ConfirmOver21Label = styled.label`
  margin-left: 23px;
  color: rgba(0, 0, 0, 0.85);
`;

export const PhoneSelect = styled(Select)`
  ${SelectAriaControlContainer} {
    border: solid 1px black;
  }
`;
